"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : DATE PICKER : STYLES --------------- ++++++++++ */


var _default = {
  datepicker: {
    width: 'fit-content',
    '& .DayPicker': {
      position: 'relative'
    },
    '& .DayPicker-Day--selected': {
      backgroundColor: "".concat(_index.theme.color.primary.medium.swatch, " !important"),
      '&.DayPicker-Day--outside': {
        backgroundColor: "".concat(_index.theme.color.light.light.swatch, " !important"),
        color: "".concat(_index.theme.color.light.light.swatch, " !important")
      }
    },
    '& .DayPicker-wrapper': {
      outline: 'none'
    },
    '& .DayPicker-Months': {
      width: '100%',
      flexWrap: 'nowrap',
      justifyContent: 'space-around',
      '& .DayPicker-Month': {
        fontSize: (0, _index.pxToEm)(16),
        display: 'block',
        borderRadius: (0, _index.pxToEm)(3),
        margin: " 0 ".concat((0, _index.pxToEm)(12), " ").concat((0, _index.pxToEm)(12), " ").concat((0, _index.pxToEm)(12))
      }
    },
    '& .DayPicker-Day': {
      borderRadius: 0,
      border: "".concat((0, _index.pxToEm)(1), " solid ").concat(_index.theme.color.neutral.light.swatch),
      fontSize: (0, _index.pxToEm)(13),
      '&.DayPicker-Day--disabled': {
        background: "".concat(_index.theme.color.neutral.xlight.swatch, " !important"),
        color: _index.theme.color.neutral.medium.swatch,
        '&.DayPicker-Day--outside': {
          background: "".concat(_index.theme.color.light.light.swatch, " !important")
        }
      },
      '&.DayPicker-Day--outside': {
        color: "".concat(_index.theme.color.light.light.swatch, " !important")
      }
    },
    '& .DayPicker-Caption': {
      textAlign: 'center',
      padding: (0, _index.pxToEm)(16),
      marginBottom: 0,
      borderLeft: "".concat((0, _index.pxToEm)(1), " solid ").concat(_index.theme.color.neutral.light.swatch),
      borderRight: "".concat((0, _index.pxToEm)(1), " solid ").concat(_index.theme.color.neutral.light.swatch),
      borderTop: "".concat((0, _index.pxToEm)(1), " solid ").concat(_index.theme.color.neutral.light.swatch)
    },
    '& .DayPicker-WeekdaysRow': {
      borderLeft: "".concat((0, _index.pxToEm)(1), " solid ").concat(_index.theme.color.neutral.light.swatch),
      borderRight: "".concat((0, _index.pxToEm)(1), " solid ").concat(_index.theme.color.neutral.light.swatch),
      '& .DayPicker-Weekday': {
        color: _index.theme.color.supporting.medium.swatch,
        fontSize: (0, _index.pxToEm)(14),
        paddingBottom: (0, _index.pxToEm)(12)
      }
    },
    '& .icon': {
      fontSize: (0, _index.pxToEm)(22)
    },
    '& .previousMonth': {
      color: _index.theme.color.primary.medium.swatch,
      position: 'absolute',
      left: (0, _index.pxToEm)(22),
      top: (0, _index.pxToEm)(14),
      height: (0, _index.pxToEm)(22),
      width: (0, _index.pxToEm)(22),
      cursor: 'pointer'
    },
    '& .nextMonth': {
      color: _index.theme.color.primary.medium.swatch,
      position: 'absolute',
      right: (0, _index.pxToEm)(22),
      top: (0, _index.pxToEm)(14),
      height: (0, _index.pxToEm)(22),
      width: (0, _index.pxToEm)(22),
      cursor: 'pointer'
    },
    '& .DayPicker-Day--today': {
      color: _index.theme.color.supporting.light.contrast
    }
  }
};
exports.default = _default;